import {
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@material-ui/core";
import moment from "moment";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { Button } from "sunrise-ui";
import { deleteThresholdValue } from "../../redux/reducers/thresholdItems";
import ConfirmationModal from "../modals/ConfirmationModal";
import "./TableComponent.scss";

const useStylesForTable = makeStyles({
  table: {
    width: "max-content",
    maxHeight: "25rem !important",
  },
  // containerWidth: {
  //   minWidth: 1120,
  // },
});

const TableComponent = (props) => {
  const tableClasses = useStylesForTable();

  //modal
  const [open, setOpen] = useState(false);

  const [rowId, setRowId] = useState("");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const dispatch = useDispatch();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleModal = () => {
    setOpen(true);
  };

  const handleDelete = (id) => {
    dispatch(
      deleteThresholdValue({
        endPoint: `threshold-info/delete-threshold-info/${id}`,
      })
    );
    setOpen(false);
    setTimeout(() => {
      props.setDeleted(true);
    }, 500);
  };
  const handleResetModal = () => {
    setOpen(false);
  };
  return (
    <>
      <TableContainer className={tableClasses.table}>
        <Table className={"custom_table"} aria-label="simple table">
          {props.data.length>0 && <TableHead>
            <TableRow>
              {props.heading.map((heading, index) => (
                <TableCell
                  key={heading}
                  className={`f16 fw500 ${index === 0 && "pl0"}`}
                  align="left"
                >
                  {heading}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>}
          {props.rows.length>0?(<TableBody>
              {props.rows
                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                ?.map((row, index) => (
                  <TableRow key={row.itemName + index}>
                    <TableCell className="f14 fw500 pl0" align="left">
                      {row.projectName}
                    </TableCell>
                    <TableCell className="f14 fw500" align="left">
                      {row.itemName}
                    </TableCell>
                    <TableCell className="f14 fw500" align="left">
                      {row.thresholdValue}
                    </TableCell>
                    <TableCell className="f14 fw500" align="left">
                      {row.unit}
                    </TableCell>
                    <TableCell className="f14 fw500" align="left">
                      {row.standardConsumptionPerMeter}
                    </TableCell>
                    <TableCell className="f14 fw500" align="left">
                      {moment(row.updatedAt).format("DD,MMM,YYYY, h:mm A")}
                    </TableCell>
                    <TableCell className="f14 fw400" align="left">
                      <Grid className="action_buttons_box d-flex">
                        <Button
                          type="button"
                          size="small"
                          isRounded={true}
                          category="primary"
                          onClick={async () => {
                            await window.scroll({
                              top: 0,
                              left: 0,
                              behavior: "smooth",
                            });
                             props.setValue(row);
                          }}
                          className="mr-1 f14"
                        >
                          Edit
                        </Button>
                        <Button
                          type="button"
                          size="small"
                          isRounded={true}
                          category="warning"
                          onClick={() => {
                            setRowId(row._id);
                            handleModal();
                          }}
                          className="f14"
                        >
                          Remove
                        </Button>
                        <ConfirmationModal
                          open={open}
                          title={"Are you sure want to remove this item?"}
                          handleCall={() => handleDelete(rowId)}
                          reset={handleResetModal}
                        />
                      </Grid>
                    </TableCell>
                  </TableRow>
                ))
            }
          </TableBody>):(<TableRow>
            <TableCell colSpan={10} align="center">
              No Data Found
            </TableCell>
          </TableRow>)}
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={props.data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
};

export default TableComponent;
